/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  AddSkillVersionRequestBody,
  AddSkillVersionRequestBody$Outbound,
  AddSkillVersionRequestBody$outboundSchema,
} from "../components/addskillversionrequestbody.js";

export type AddSkillVersionSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type AddSkillVersionSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type AddSkillVersionSecurity = {
  option1?: AddSkillVersionSecurityOption1 | undefined;
  option2?: AddSkillVersionSecurityOption2 | undefined;
};

export type AddSkillVersionRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  addSkillVersionRequestBody: AddSkillVersionRequestBody;
};

/** @internal */
export type AddSkillVersionSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const AddSkillVersionSecurityOption1$outboundSchema: z.ZodMiniType<
  AddSkillVersionSecurityOption1$Outbound,
  AddSkillVersionSecurityOption1
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function addSkillVersionSecurityOption1ToJSON(
  addSkillVersionSecurityOption1: AddSkillVersionSecurityOption1,
): string {
  return JSON.stringify(
    AddSkillVersionSecurityOption1$outboundSchema.parse(
      addSkillVersionSecurityOption1,
    ),
  );
}

/** @internal */
export type AddSkillVersionSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const AddSkillVersionSecurityOption2$outboundSchema: z.ZodMiniType<
  AddSkillVersionSecurityOption2$Outbound,
  AddSkillVersionSecurityOption2
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function addSkillVersionSecurityOption2ToJSON(
  addSkillVersionSecurityOption2: AddSkillVersionSecurityOption2,
): string {
  return JSON.stringify(
    AddSkillVersionSecurityOption2$outboundSchema.parse(
      addSkillVersionSecurityOption2,
    ),
  );
}

/** @internal */
export type AddSkillVersionSecurity$Outbound = {
  Option1?: AddSkillVersionSecurityOption1$Outbound | undefined;
  Option2?: AddSkillVersionSecurityOption2$Outbound | undefined;
};

/** @internal */
export const AddSkillVersionSecurity$outboundSchema: z.ZodMiniType<
  AddSkillVersionSecurity$Outbound,
  AddSkillVersionSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => AddSkillVersionSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => AddSkillVersionSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function addSkillVersionSecurityToJSON(
  addSkillVersionSecurity: AddSkillVersionSecurity,
): string {
  return JSON.stringify(
    AddSkillVersionSecurity$outboundSchema.parse(addSkillVersionSecurity),
  );
}

/** @internal */
export type AddSkillVersionRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
  AddSkillVersionRequestBody: AddSkillVersionRequestBody$Outbound;
};

/** @internal */
export const AddSkillVersionRequest$outboundSchema: z.ZodMiniType<
  AddSkillVersionRequest$Outbound,
  AddSkillVersionRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    addSkillVersionRequestBody: AddSkillVersionRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
      addSkillVersionRequestBody: "AddSkillVersionRequestBody",
    });
  }),
);

export function addSkillVersionRequestToJSON(
  addSkillVersionRequest: AddSkillVersionRequest,
): string {
  return JSON.stringify(
    AddSkillVersionRequest$outboundSchema.parse(addSkillVersionRequest),
  );
}
